module.exports = __webpack_public_path__ + "img/5_ku.eed51283.jpg";